// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".radio__inputWrapper--MRHVo {\n  align-items: center;\n  display: flex;\n  position: relative;\n  width: 100%;\n}\n\n.radio__input--E8GJp {\n  margin-right: 0.625rem;\n}\n", "",{"version":3,"sources":["webpack://./src/components/form/radio.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,sBAAqB;AACvB","sourcesContent":[".inputWrapper {\n  align-items: center;\n  display: flex;\n  position: relative;\n  width: 100%;\n}\n\n.input {\n  margin-right: rem(10);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"inputWrapper": "radio__inputWrapper--MRHVo",
	"input": "radio__input--E8GJp"
};
module.exports = ___CSS_LOADER_EXPORT___;
